import FeatureRouteGuard from "./FeatureRouteGuard";

const ApplicationsRouteGuard = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <FeatureRouteGuard flag="applications_enabled" permission="mandate.view">
    {children}
  </FeatureRouteGuard>
);

export default ApplicationsRouteGuard;
